import { Directive, ViewContainerRef } from '@angular/core';

@Directive({ selector: '[grecoFormContainer]' })
export class CreatePaymentMethodFormContainerDirective {
  constructor(public readonly viewRef: ViewContainerRef) {}
}
